/**
 * mergeIds.ts
 * Side-effect-free array merge utility for collectible IDs.
 *
 * Extracted from level1Session.ts so tests can import this utility
 * without triggering loadTileMap at module load time.
 *
 * @module mergeIds
 */

/**
 * Merge previously collected IDs with newly collected IDs (deduped).
 * @param prev - IDs from a previous save (may be undefined).
 * @param next - IDs collected this session.
 * @returns Deduplicated union of both arrays.
 */
export function mergeIds(prev: string[] | undefined, next: string[]): string[] {
  // DECISION: Always dedupe via Set — even when prev is empty — so callers
  // never receive duplicates that may exist within `next` itself.
  const set = new Set<string>(prev ?? []);
  for (const id of next) set.add(id);
  return [...set];
}
